var lastDayOfMonth = function (date) {
    return +moment(date).endOf('month').toISOString().substr(8, 2)
}

angular.module('SpidApp')

.factory('StockChartUtils', [function () {
    return {
        sum: function (arr) {
            return arr.reduce(function(memo, value) {
              return memo + value;
            }, 0);
        },
        
        cut: function (arr, n) {
            return arr.slice(0, n)
        },
        
        cumulativeDistribution: function (data) {
            var res = []
            
            for(var i = 0 ; i < data.length ; i++) {
                res[i] = data[i] + this.sum( this.cut(data, i) )
            }
            
            return res
        }
    }
}])

.factory('MonthStockChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var MonthStockChartGenerator = function (stockflows, when) {
        stockflows = stockflows || []
        
        var stockflowsOrderedByDay = _.chain(stockflows).groupBy(function (stockflow) {
            return moment(stockflow.updated_at).format('DD/MM/YYYY') // TODO: bad locale flow
        }).mapObject(function (stockflows) {
            return _.reduce(stockflows, function (memo, stockflow) {
                return memo + stockflow.diff
            }, 0)
        }).value()
        
        var labels = []
        var values = []
        
        var today = moment(when)
        var endOfMonth = moment(when)
        endOfMonth.set('date', lastDayOfMonth(today))
        var curseur = moment(endOfMonth)
        var nDays = lastDayOfMonth(today)
        
        for(var i = 0 ; i < nDays ; i++) {
            var key = curseur.format('DD/MM/YYYY')
            
            labels.push(key)
            values[i] = stockflowsOrderedByDay[key] || 0
            
            curseur.subtract(1, 'day')
        }
        labels = labels.reverse()
        values = values.reverse()
        
        for(i = 1 ; i <= nDays ; i++) {
            labels[i-1] = i + ''
        }
        
        this.series = ['Flux du produit']
        this.labels = labels
        this.data = [ StockChartUtils.cumulativeDistribution( values ) ]
        this.options = {
              animation            : true
            , showTooltips         : true
            , showScale            : true
            , scaleBeginAtZero     : true
            , showGridLines        : false
        }
        this.colours = [{
              fillColor   : '#FFE7A0'
            , strokeColor : '#FFC928'
        }]
    }
        
    MonthStockChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , data       : this.data
            , options    : this.options
            , colours    : this.colours
        }
    }
    
    return MonthStockChartGenerator
}])

.factory('YearStockChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var YearStockChartGenerator = function (stockflows, when) {
        stockflows = stockflows || []
        
        var stockflowsOrderedByMonth = _.chain(stockflows).groupBy(function (stockflow) {
            return moment(stockflow.updated_at).format('MM/YYYY') // TODO: bad locale flow
        }).mapObject(function (stockflows) {
            return _.reduce(stockflows, function (memo, stockflow) {
                return memo + stockflow.diff
            }, 0)
        }).value()
        
        var labels = []
        var values = []
        
        var startOfYear = moment(when)
        startOfYear.set('date', 1)
        startOfYear.set('month', 0)
        
        var endOfYear = moment(when)
        endOfYear.set('date', 31)
        endOfYear.set('month', 11)
        
        var curseur = moment(endOfYear)
        
        for(var i = 0 ; i < 12 ; i++) {
            var key = curseur.format('MM/YYYY')
            
            labels.push(key)
            values[i] = stockflowsOrderedByMonth[key] || 0
            
            curseur.subtract(1, 'month')
        }
        labels = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
        values = values.reverse()
        
        
        
        this.series = ['Flux du produit']
        this.labels = labels
        this.data = [ StockChartUtils.cumulativeDistribution( values ) ]
        this.options = {
              animation            : true
            , showTooltips         : true
            , showScale            : true
            , scaleBeginAtZero     : true
            , showGridLines        : false
        }
        this.colours = [{
              fillColor   : '#FFE7A0'
            , strokeColor : '#FFC928'
        }]
    }
        
    YearStockChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , data       : this.data
            , options    : this.options
            , colours    : this.colours
        }
    }
    
    return YearStockChartGenerator
}])